import { useAccountEditQry } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import toast from 'react-hot-toast'
import '../AccountCreateModal/AccountCreateModal.scss'

interface Props {
  account: AccountBalanceResponse
}

function AccountEditModal({ account }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const { id: accountId, name: accountName } = account || {}

  const { formValues, editAccountError, editAccountFetching, handleSubmit } = useAccountEditQry({
    accountId,
    accountName,
    onSuccess: () => {
      toast.remove()
      toast.success(tr('PORTAL.ACCOUNTS.EDIT.SUCCESS_MESSAGE', 'Account successfully updated'))
      modalHide()
    }
  })

  return (
    <div className='account-create-wrapper' data-test='create-account-modal'>
      <div className='account-create-title title mb-2'>{tr('PORTAL.ACCOUNTS.EDIT.TITLE', 'Edit account')}</div>

      <form className='account-create-form' noValidate>
        <Input
          type='text'
          data-test='account-name'
          label={tr('PORTAL.ACCOUNTS.EDIT.NAME', 'Account name')}
          {...formValues.registerInput('name')}
          autoFocus
        />

        <ErrorDisplay error={editAccountError} />

        <div className='account-create-buttons'>
          <Button
            type='button'
            color='primary'
            text={tr('PORTAL.ACCOUNTS.EDIT.SUBMIT_BUTTON', 'Save')}
            loading={editAccountFetching}
            data-test='button-submit'
            onClick={handleSubmit}
          />

          <Button
            type='button'
            color='secondary'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            disabled={editAccountFetching}
            data-test='button-cancel'
            onClick={modalHide}
          />
        </div>
      </form>
    </div>
  )
}

export default AccountEditModal
